module.exports = __webpack_public_path__ + "img/c6b336a12ee375b3712bb8f649cb17ee.c8ac3db6.webp";